module.exports = __webpack_public_path__ + "ca8c304c8f08851be5065a9d03ba52b1.svg";